import { Component, OnInit, Input, EventEmitter, Output, Renderer2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'successful-submission-dialog',
    templateUrl: './successful-submission-dialog.component.html',
    styleUrls: ['./successful-submission-dialog.component.scss'],
})
export class SuccessfulSubmissionDialogComponent implements OnInit {
    @Input() title: string;
    @Input() message: string;
    @Output() viewClickedAfterSuccess?: EventEmitter<any> = new EventEmitter<any>();
    @Output() topRightXClickedAfterSuccess?: EventEmitter<any> = new EventEmitter<any>();
    @Output() editClickedAfterSuccess?: EventEmitter<any> = new EventEmitter<any>();

    constructor(private renderer: Renderer2, @Inject(DOCUMENT) private document: Document) {}

    ngOnInit() {
        this.renderer.addClass(this.document.body, 'modal-open');
    }

    viewClicked() {
        this.viewClickedAfterSuccess.emit();
    }

    editClicked() {
        this.editClickedAfterSuccess.emit();
    }

    topRightXClicked() {
        this.topRightXClickedAfterSuccess.emit();
    }

    ngOnDestroy() {
        this.renderer.removeClass(this.document.body, 'modal-open');
    }
}
